import { styled } from 'styled-components';
import { Text } from '../Text';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-1285v5y-0"
})(["display:flex;flex-direction:", ";align-items:", ";gap:var(--aui-spacing-200);flex-grow:1;min-height:100%;"], ({
  $imagePosition
}) => ({
  top: 'column',
  left: 'row',
  right: 'row-reverse'
})[$imagePosition], ({
  $imagePosition,
  $alignment
}) => $imagePosition === 'top' ? $alignment === 'left' ? 'flex-start' : 'center' : 'stretch');
export const BodyContainer = styled.div.withConfig({
  componentId: "aui__sc-1285v5y-1"
})(["flex-grow:1;display:flex;flex-direction:column;align-items:", ";text-align:", ";justify-content:", ";gap:", ";color:var(--aui-on-surface);"], ({
  $alignment
}) => $alignment === 'left' ? 'flex-start' : 'center', ({
  $alignment
}) => $alignment, ({
  $imagePosition
}) => $imagePosition === 'top' ? 'flex-start' : 'center', ({
  $size
}) => $size === 'xl' ? 'var(--aui-spacing-200)' : 'var(--aui-spacing-100)');
export const HeadingContainer = styled.div.withConfig({
  componentId: "aui__sc-1285v5y-2"
})(["align-items:inherit;display:flex;flex-direction:column;gap:var(--aui-spacing-050);"]);
export const Eyebrow = styled(Text).attrs({
  family: 'mono',
  size: 0
}).withConfig({
  componentId: "aui__sc-1285v5y-3"
})(["color:var(--aui-on-surface-soft);"]);